import { getPageApiBaseUrl } from '@/core/utils/apiUtils';
import {
  adaptPlpResponseDtoToDomain,
  plainPlpResponseToListingPageResult,
  productListingToPlainObject,
} from '@/features/plp/infra/mappers/plp.mapper';
import type { ListingPageResult } from '@/features/plp/domain/models/ProductListing';

const EMPTY_LISTING: ListingPageResult = {
  header: '',
  totalCount: 0,
  filters: [],
  designs: [],
};

function buildBatchDesignUrl(): string {
  const base = getPageApiBaseUrl().replace(/\/+$/, '');
  return base.endsWith('/page') ? `${base}/batch/design/` : `${base}/page/batch/design/`;
}

/** POST design IDs to /page/batch/design/ (old-react imageSearchDesigns). */
export async function fetchImageSearchListingPage(
  designIds: string[],
  opts?: { signal?: AbortSignal },
): Promise<ListingPageResult> {
  if (designIds.length === 0) return EMPTY_LISTING;

  const res = await fetch(buildBatchDesignUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(designIds),
    credentials: 'omit',
    signal: opts?.signal,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Image search batch design failed (${res.status}). ${text}`.trim());
  }

  const dto = (await res.json()) as Record<string, unknown>;
  const domain = adaptPlpResponseDtoToDomain(dto);
  return plainPlpResponseToListingPageResult(productListingToPlainObject(domain));
}
